/**
 * @deprecated It will be removed in 6 months 10-03-2026. Use string literals instead.
 */
export const Variant = {
    PRIMARY: 'Type.PRIMARY',
    SECONDARY: 'Type.SECONDARY',
    TERTIARY: 'Type.TERTIARY',
    PAGINATION: 'Type.PAGINATION',
    BACK: 'Type.BACK',
} as const;

/**
 * @deprecated It will be removed in 6 months 10-03-2026. Use string literals instead.
 */
export const ColorVariant = {
    ERROR: 'ERROR',
    ACCENT: 'ACCENT',
    DEFAULT: 'DEFAULT',
} as const;


export const VARIANT_CLASSES = {
    'Type.PRIMARY': 'button_primary',
    'Type.SECONDARY': 'button_secondary',
    'Type.TERTIARY': 'button_tertiary',
    'Type.PAGINATION': 'button_pagination',
    'Type.BACK': 'button_back',
};

export const COLOR_VARIANT_CLASSES = {
    DEFAULT: null,
    ERROR: 'button_error',
    ACCENT: 'button_accent',
};
